export { default as SecuredRoutes } from 'secured/routes/SecuredRoutes';



// WEBPACK FOOTER //
// src/modules/secured/routes/index.js